var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.writeLayouts),function(writeLayout){return _c('point-write-link',{key:`pointComp${writeLayout}`,attrs:{"writeLayout":writeLayout,"pointData":_vm.pointData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }